import _extends from '@babel/runtime/helpers/extends';
import React__default, { Children, isValidElement, cloneElement } from 'react';
import PT from 'prop-types';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';

const StyledLegend = /*#__PURE__*/styled('legend').withConfig({
  componentId: "sc-storm-ui-30054544__sc-tgsbuj-0"
})(["", ";color:", ";font-weight:", ";padding:0;", " ", " display:block;box-sizing:border-box;padding-inline-start:unset;padding-inline-end:unset;", ";"], ({
  theme
}) => theme.typography.base, ({
  theme
}) => theme.form.label.color, ({
  theme
}) => theme.form.label.weight, ({
  hidden,
  theme
}) => hidden && theme.typography.screenReaderOnly, isMobile(css(["", ";margin-bottom:", ";"], ({
  theme
}) => theme.typography.mobile.base, ({
  theme
}) => theme.spacing.micro)), ({
  disabled
}) => disabled && css(["cursor:not-allowed;outline:none;color:", ";"], ({
  theme
}) => theme.form.label.colorDisabled));
StyledLegend.displayName = 'StyledLegend';
const CheckboxGroupItem = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30054544__sc-tgsbuj-1"
})(["margin-bottom:4px;word-wrap:break-word;", " label{width:100%;}"], isMobile(css(["background-color:", ";border-bottom:1px solid ", ";margin:0;padding:0 ", ";:first-of-type{border-radius:", " ", " 0 0;}:last-of-type{border-radius:0 0 ", " ", ";border-bottom:none;}"], ({
  theme
}) => theme.form.checkbox.mobile.groupBackgroundColor, ({
  theme
}) => theme.form.checkbox.mobile.groupBorderColor, ({
  theme
}) => theme.mobile.spacing.small, ({
  theme
}) => theme.form.checkbox.mobile.groupBorderRadius, ({
  theme
}) => theme.form.checkbox.mobile.groupBorderRadius, ({
  theme
}) => theme.form.checkbox.mobile.groupBorderRadius, ({
  theme
}) => theme.form.checkbox.mobile.groupBorderRadius)));
const CheckboxGroupContainer = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30054544__sc-tgsbuj-2"
})(["", " ", ""], ({
  $groupIndicator
}) => $groupIndicator === 'bar' ? css(["border-inline-start:1px solid ", ";padding-inline-start:14px;margin-inline-start:7px;"], ({
  theme
}) => theme.palette.gray[300]) : undefined, isMobile(css(["background-color:", ";border:1px solid ", ";border-radius:", ";display:block;padding-inline-start:unset;margin-inline-start:unset;"], ({
  theme
}) => theme.form.checkbox.mobile.groupBackgroundColor, ({
  theme
}) => theme.form.checkbox.mobile.groupBorderColor, ({
  theme
}) => theme.form.checkbox.mobile.groupBorderRadius)));
const CheckboxGroupFieldset = /*#__PURE__*/styled('fieldset').withConfig({
  componentId: "sc-storm-ui-30054544__sc-tgsbuj-3"
})(["border:none;margin:0;padding:0;margin-block-start:unset;margin-block-end:unset;margin-inline-start:unset;margin-inline-end:unset;padding-inline-start:unset;"]);
const CheckboxGroup = ({
  children,
  className,
  disabled,
  hideLabel,
  label,
  groupIndicator = 'none',
  ...rest
}) => children && /*#__PURE__*/React__default.createElement(CheckboxGroupFieldset, _extends({
  className: className,
  disabled: disabled
}, rest), /*#__PURE__*/React__default.createElement(StyledLegend, {
  disabled: disabled,
  hidden: hideLabel
}, label), /*#__PURE__*/React__default.createElement(CheckboxGroupContainer, {
  $groupIndicator: groupIndicator
}, Children.map(children, child => {
  /* Only set disabled when the child is react Element */
  if (/*#__PURE__*/isValidElement(child)) {
    return /*#__PURE__*/React__default.createElement(CheckboxGroupItem, null, /*#__PURE__*/cloneElement(child, {
      ...child.props,
      disabled: disabled || child.props.disabled
    }));
  }
  return child;
})));
CheckboxGroup.propTypes = {
  /**
   * An array of <Checkbox /> components.
   */
  children: PT.arrayOf(PT.node).isRequired,
  /**
   * Utilized when wrapping the checkbox in a styled-component. Passes the styles specified by the
   * styled-component to the checkbox wrapper component.
   */
  className: PT.string,
  /**
   * The group's label text. Labels are required for screen reader accessibility.
   */
  label: PT.oneOfType([PT.node, PT.string]).isRequired,
  /**
   * Specifies if the checkbox group is disabled, which disables the entire group if true. If this
   * is false, checkboxes can still be disabled individually.
   */
  disabled: PT.bool,
  /**
   * Labels are required for screen reader accessibility, but can be hidden visually.
   */
  hideLabel: PT.bool,
  /**
   * Adds an inline border to indicate grouped items
   */
  groupIndicator: PT.oneOf(['none', 'bar'])
};
CheckboxGroup.defaultProps = {
  disabled: false,
  hideLabel: false,
  className: undefined,
  groupIndicator: 'none'
};
CheckboxGroup.displayName = 'CheckboxGroup';

export { CheckboxGroup as C };
//# sourceMappingURL=CheckboxGroup-CTp9POcE.js.map
